import React, { useEffect, useState } from "react";
import axios from "axios";
import { API } from "../config";
import { useParams, useNavigate } from "react-router-dom";

export default function HojaVidaEstudiante({ matriculaId: propMatriculaId }) {

  const params = useParams();
  const navigate = useNavigate();

  const matriculaId = propMatriculaId || params?.id;

  const [data, setData] = useState(null);
  const [matriculas, setMatriculas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadingList, setLoadingList] = useState(true);
  const [error, setError] = useState(null);
  const [filtro, setFiltro] = useState("todos");

  /* =====================================================
     📥 HOJA DE VIDA
  ====================================================== */
  useEffect(() => {

    if (!matriculaId) {
      setLoading(false);
      setError("No se encontró el ID de la matrícula");
      return;
    }

    const fetchData = async () => {
      try {
        setLoading(true);
        setError(null);

        console.log("Cargando hoja de vida ID:", matriculaId);

        const res = await axios.get(
          `${API}/hoja-vida/${matriculaId}`,
          { withCredentials: true }
        );

        setData(res.data);

      } catch (err) {
        console.error(err);
        setError("Error cargando hoja de vida");
      } finally {
        setLoading(false);
      }
    };

    fetchData();

  }, [matriculaId]);

  /* =====================================================
     📥 MATRÍCULAS (SELECT)
  ====================================================== */
  useEffect(() => {

    const fetchMatriculas = async () => {
      try {
        setLoadingList(true);

        const res = await axios.get(
          `${API}/matriculas`,
          { withCredentials: true } // 🔥 IMPORTANTE PARA 401
        );

        setMatriculas(res.data || []);

      } catch (err) {
        console.error("Error cargando matrículas", err);
      } finally {
        setLoadingList(false);
      }
    };

    fetchMatriculas();

  }, []);

  /* =====================================================
     🔴 ESTADOS
  ====================================================== */
  if (loading) return <p>⏳ Cargando hoja de vida...</p>;
  if (error) return <p style={{ color: "red" }}>{error}</p>;

  const hojaVida = data?.hojaVida || {};
  const registros = Array.isArray(data?.registros) ? data.registros : [];

  const registrosFiltrados =
    filtro === "todos"
      ? registros
      : registros.filter(r => r?.tipo === filtro);

  /* =====================================================
     🔽 CAMBIO DE ESTUDIANTE
  ====================================================== */
  const cambiarEstudiante = (id) => {
    if (!id) return;
    navigate(`/hoja-vida-estudiante/${id}`);
  };

  return (
    <div style={styles.container}>

      {/* =====================================================
          🔽 SELECT ESTUDIANTES
      ====================================================== */}
      <div style={styles.selectBox}>
        <h3>👨‍🎓 Seleccionar estudiante</h3>

        {loadingList ? (
          <p>Cargando estudiantes...</p>
        ) : (
          <select
            style={styles.select}
            value={matriculaId || ""}
            onChange={(e) => cambiarEstudiante(e.target.value)}
          >
            <option value="">-- Selecciona un estudiante --</option>

            {matriculas.map((m) => (
              <option key={m.id} value={m.id}>
                {m.nombres_estudiante} {m.apellidos_estudiante} - {m.documento_estudiante}
              </option>
            ))}
          </select>
        )}
      </div>

      {/* =====================================================
          👤 HEADER
      ====================================================== */}
      <div style={styles.header}>
        <h2>📘 Hoja de Vida Estudiantil</h2>

        <p>
          <b>Documento:</b> {hojaVida?.documento_estudiante || "N/A"} |{" "}
          <b>Grado:</b> {hojaVida?.grado || "-"}-{hojaVida?.grupo || "-"}
        </p>
      </div>

      {/* =====================================================
          🔘 FILTROS
      ====================================================== */}
      <div style={styles.filtros}>
        {["todos", "academico", "disciplinario", "logro", "alerta"].map(t => (
          <button
            key={t}
            onClick={() => setFiltro(t)}
            style={{
              ...styles.btn,
              background: filtro === t ? "#1e88e5" : "#eee",
              color: filtro === t ? "#fff" : "#000"
            }}
          >
            {t.toUpperCase()}
          </button>
        ))}
      </div>

      {/* =====================================================
          📊 TIMELINE
      ====================================================== */}
      <div style={styles.timeline}>

        {registrosFiltrados.length === 0 && (
          <p>No hay registros</p>
        )}

        {registrosFiltrados.map((r) => (
          <div key={r.id} style={styles.card}>

            <div style={styles.cardHeader}>
              <span style={styles.tipo}>
                {r?.tipo?.toUpperCase() || "SIN TIPO"}
              </span>

              <span style={styles.nivel}>
                {r?.nivel || "N/A"}
              </span>
            </div>

            <h4>{r?.titulo}</h4>
            <p>{r?.descripcion}</p>

            <small>
              👨‍🏫 {r?.rol_emisor || "sistema"} | 📅{" "}
              {r?.creado_en
                ? new Date(r.creado_en).toLocaleString()
                : "sin fecha"}
            </small>

          </div>
        ))}

      </div>
    </div>
  );
}

/* =====================================================
   🎨 ESTILOS
===================================================== */
const styles = {
  container: {
    padding: 20,
    fontFamily: "Arial"
  },

  selectBox: {
    marginBottom: 20,
    padding: 15,
    background: "#fafafa",
    borderRadius: 10,
    border: "1px solid #ddd"
  },

  select: {
    width: "100%",
    padding: 10,
    marginTop: 10,
    borderRadius: 6,
    border: "1px solid #ccc"
  },

  header: {
    padding: 15,
    background: "#f5f5f5",
    borderRadius: 10,
    marginBottom: 15
  },

  filtros: {
    display: "flex",
    gap: 10,
    marginBottom: 20
  },

  btn: {
    padding: "8px 12px",
    border: "none",
    borderRadius: 6,
    cursor: "pointer"
  },

  timeline: {
    display: "flex",
    flexDirection: "column",
    gap: 15
  },

  card: {
    padding: 15,
    borderRadius: 10,
    background: "#fff",
    border: "1px solid #ddd"
  },

  cardHeader: {
    display: "flex",
    justifyContent: "space-between"
  },

  tipo: {
    fontWeight: "bold",
    color: "#1976d2"
  },

  nivel: {
    fontSize: 12,
    padding: "2px 6px",
    background: "#eee",
    borderRadius: 5
  }
};